import { createSlice } from '@reduxjs/toolkit';

const getInitialSettings = () => ({
  theme: 'light',
  sidebarCollapsed: false,
  language: 'en',
  notifications: true,
});

const settingsSlice = createSlice({
  name: 'settings',
  initialState: getInitialSettings(),
  reducers: {
    setTheme: (state, action) => {
      state.theme = action.payload;
      document.documentElement.setAttribute('data-theme', action.payload);
    },
    toggleSidebar: (state) => {
      state.sidebarCollapsed = !state.sidebarCollapsed;
    },
    setSidebarCollapsed: (state, action) => {
      state.sidebarCollapsed = action.payload;
    },
    setLanguage: (state, action) => {
      state.language = action.payload;
    },
    setNotifications: (state, action) => {
      state.notifications = action.payload;
    },
    resetSettings: () => getInitialSettings(),
  },
});

export const {
  setTheme,
  toggleSidebar,
  setSidebarCollapsed,
  setLanguage,
  setNotifications,
  resetSettings,
} = settingsSlice.actions;
export default settingsSlice.reducer;
